import { useState } from 'react';
import type { IDisplaySchedule } from 'src/utils/schedules/mapSchedules';
import type { IScheduleWeek, PublishItem } from 'src/utils/schedules/groupPublishingByWeek';

export const usePublishScheduleFilters = () => {
  const [eventTypes, setEventTypes] = useState<string[]>([]);
  const [weekTitles, setWeekTitles] = useState<string[]>([]);
  const [venueIds, setVenueIds] = useState<string[]>([]);
  const [priceSchemeIds, setPriceSchemeIds] = useState<string[]>([]);

  const filterSchedules = (schedules: IDisplaySchedule[]): IDisplaySchedule[] =>
    schedules.filter((schedule) => {
      if (eventTypes.length && !eventTypes.includes(schedule.event_type)) return false;
      if (venueIds.length && !schedule.venues.some((venue) => venueIds.includes(venue.venue_id))) return false;
      if (
        priceSchemeIds.length &&
        !(schedule.price_scheme && priceSchemeIds.includes(schedule.price_scheme.price_scheme_id))
      )
        return false;
      return true;
    });

  const filterWeeks = <T extends PublishItem>(weeks: IScheduleWeek<T>[]): IScheduleWeek<T>[] =>
    weekTitles.length ? weeks.filter((week) => weekTitles.includes(week.title)) : weeks;

  return {
    eventTypes,
    setEventTypes,
    weekTitles,
    setWeekTitles,
    venueIds,
    setVenueIds,
    priceSchemeIds,
    setPriceSchemeIds,
    filterSchedules,
    filterWeeks,
  };
};
